"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _recommendCourse = require("@/api/recommendCourse");
var _filePreview = _interopRequireDefault(require("@/components/filePreview.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var OUTLINE_PENDING_KEY = "course_outline_pending";
var _default = exports.default = {
  components: {
    FilePreview: _filePreview.default
  },
  data: function data() {
    return {
      form: {},
      rules: {
        content: [{
          required: true,
          message: "请输入课程评价",
          trigger: "blur"
        }],
        star: [{
          required: true,
          message: "请打分",
          trigger: "blur"
        }]
      },
      evaluateOpen: false,
      courseSpeed: {},
      noPic: this.$store.getters.noImg,
      options: [{
        label: "电子与信息技术基础",
        options: [{
          value: "Shanghai",
          label: "第 1 次开课"
        }, {
          value: "Beijing",
          label: "第 2 次开课"
        }]
      }, {
        label: "大学英语",
        options: [{
          value: "Chengdu",
          label: "2021班-1"
        }, {
          value: "Shenzhen",
          label: "2021班-2"
        }, {
          value: "Guangzhou",
          label: "2022班-1"
        }, {
          value: "Dalian",
          label: "2022班-2"
        }]
      }],
      value: "",
      tabActive: 0,
      tabs: ["课程介绍", "课程公告", "课程大纲"],
      list: [],
      query: {
        pageSize: 20,
        pageNum: 1,
        courseInfoId: this.$route.query.id
      },
      isShow: null,
      data: [{
        label: "一级 1",
        children: [{
          label: "二级 1-1",
          children: [{
            label: "三级 1-1-1"
          }]
        }]
      }, {
        label: "一级 2",
        children: [{
          label: "二级 2-1",
          children: [{
            label: "三级 2-1-1"
          }]
        }, {
          label: "二级 2-2",
          children: [{
            label: "三级 2-2-1"
          }]
        }]
      }, {
        label: "一级 3",
        children: [{
          label: "二级 3-1",
          children: [{
            label: "三级 3-1-1"
          }]
        }, {
          label: "二级 3-2",
          children: [{
            label: "三级 3-2-1"
          }]
        }]
      }],
      defaultProps: {
        children: "children",
        label: "name"
      },
      courseTree: [],
      courseDetail: {
        teacherList: [],
        courseInfoMaterialList: []
      },
      noImg: require("@/assets/img/default-photo-teacher.png"),
      noticeList: [],
      noticeTotal: 0,
      filePreviewVisible: false,
      fileStr: '',
      currentFileData: null,
      pendingOutlineNode: null
    };
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      var userInfo = this.$store.getters.userInfo || {};
      return Boolean(this.$store.getters.token && userInfo.userName);
    }
  },
  watch: {
    isLoggedIn: function isLoggedIn(value, oldValue) {
      if (value && !oldValue) {
        this.restorePendingOutlineNode();
      }
    }
  },
  filters: {
    date: function date(val) {
      if (val) return val.slice(0, 10);
    },
    day: function day(val) {
      if (val) return val.slice(8, 10);
    },
    year: function year(val) {
      if (val) return val.slice(0, 7);
    }
  },
  methods: {
    // 获取课程详情进度
    //  courseId: this.$route.query.courseId,
    //     courseInfoId: this.$route.query.id,
    getSpeed: function getSpeed() {
      var _this = this;
      (0, _recommendCourse.studyDetail)({
        courseInfoId: this.$route.query.id
      }).then(function (res) {
        _this.courseSpeed = res.data;
        _this.courseSpeed.studyTime = (res.data.studyTime / 3600).toFixed(2);
      });
    },
    // 课程评价
    evaluate: function evaluate() {
      // if (localStorage.getItem("activeIndex") == 3) {
      //   return this.$modal.msgWarning("该课程暂未开始，不能评价！");
      // }
      // this.resetForm("form");
      this.evaluateOpen = true;
    },
    evaluateSubmit: function evaluateSubmit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.form.courseInfoId = _this2.$route.query.id;
          (0, _recommendCourse.addCourseEvaluate)(_this2.form).then(function (res) {
            if (res.code == 200) {
              _this2.getSpeed();
            }
          });
          _this2.evaluateOpen = false;
        } else {
          return false;
        }
      });
    },
    toJiaocai: function toJiaocai(i) {
      window.open(i.linkUrl);
    },
    join: function join() {
      var _this3 = this;
      if (this.courseDetail.isLogin) {
        if (!this.courseDetail.isJoin) {
          (0, _recommendCourse.courseInfoStudent)({
            courseId: this.$route.query.courseId,
            courseInfoId: this.$route.query.id,
            courseInfoName: this.courseDetail.name,
            courseName: this.courseDetail.courseName,
            courseInfoTime: this.courseDetail.startTime,
            courseInfoValidNumber: this.courseDetail.courseInfoValidNumber,
            imageUrl: this.courseDetail.imageUrl,
            peopleNumber: this.courseDetail.peopleNumber,
            typeId: this.courseDetail.typeId
          }).then(function (res) {
            _this3.courseDetail.isJoin = !_this3.courseDetail.isJoin;
            _this3.$message.success("操作成功！");
          });
          aplus_queue.push({
            action: "aplus.record",
            arguments: ["course_learn_button_click", "CLK", {
              //以下为事件属性
              course_name: this.courseDetail.courseName,
              // 课程名称
              course_id: this.courseDetail.courseId //课程id
            }]
          });
        } else {
          this.$message.success("您已加入本课程！");
        }
      } else {
        this.$message.error("请先登录！");
      }
    },
    collect: function collect() {
      var _this4 = this;
      if (this.courseDetail.isLogin) {
        if (!this.courseDetail.isCollection) {
          (0, _recommendCourse.myCollection)({
            courseId: this.$route.query.courseId,
            courseInfoId: this.$route.query.id,
            courseInfoName: this.courseDetail.name,
            courseName: this.courseDetail.courseName,
            courseInfoTime: this.courseDetail.startTime,
            courseInfoValidNumber: this.courseDetail.courseInfoValidNumber,
            imageUrl: this.courseDetail.imageUrl,
            peopleNumber: this.courseDetail.peopleNumber,
            typeId: this.courseDetail.typeId
          }).then(function (res) {
            _this4.courseDetail.isCollection = !_this4.courseDetail.isCollection;
            _this4.$message.success("操作成功！");
          });
        } else {
          this.$message.success("您已收藏本课程！");
        }
      } else {
        this.$message.error("请先登录！");
      }
    },
    lookDetail: function lookDetail(i) {
      if (this.isShow === i) {
        this.isShow = null;
      } else {
        this.isShow = i;
      }
    },
    openLogin: function openLogin() {
      this.$root.$emit('open-portal-login');
    },
    savePendingOutlineNode: function savePendingOutlineNode(data) {
      var pendingNode = {
        courseId: this.$route.query.courseId,
        courseInfoId: this.$route.query.id,
        nodeId: data.id,
        nodeName: data.name || data.label
      };
      this.pendingOutlineNode = {
        courseId: pendingNode.courseId,
        courseInfoId: pendingNode.courseInfoId,
        nodeId: pendingNode.nodeId,
        nodeName: pendingNode.nodeName,
        data: data,
        node: null
      };
      sessionStorage.setItem(OUTLINE_PENDING_KEY, JSON.stringify(pendingNode));
    },
    clearPendingOutlineNode: function clearPendingOutlineNode() {
      this.pendingOutlineNode = null;
      sessionStorage.removeItem(OUTLINE_PENDING_KEY);
    },
    findPendingOutlineData: function findPendingOutlineData(nodes, pendingNode) {
      var _iterator = _createForOfIteratorHelper(nodes || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          var sameId = pendingNode.nodeId !== undefined && pendingNode.nodeId !== null && String(node.id) === String(pendingNode.nodeId);
          var sameName = (pendingNode.nodeId === undefined || pendingNode.nodeId === null) && pendingNode.nodeName && (node.name || node.label) === pendingNode.nodeName;
          if (sameId || sameName) {
            return node;
          }
          var result = this.findPendingOutlineData(node.children, pendingNode);
          if (result) {
            return result;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    },
    restorePendingOutlineNode: function restorePendingOutlineNode() {
      var _this5 = this;
      if (!this.isLoggedIn || !this.courseTree || !this.courseTree.length) {
        return;
      }
      var pendingNode = this.pendingOutlineNode;
      if (!pendingNode) {
        var pendingNodeText = sessionStorage.getItem(OUTLINE_PENDING_KEY);
        if (!pendingNodeText) {
          return;
        }
        try {
          pendingNode = JSON.parse(pendingNodeText);
        } catch (error) {
          sessionStorage.removeItem(OUTLINE_PENDING_KEY);
          return;
        }
      }
      if (String(pendingNode.courseInfoId) !== String(this.$route.query.id) || pendingNode.courseId && String(pendingNode.courseId) !== String(this.$route.query.courseId)) {
        this.clearPendingOutlineNode();
        return;
      }
      if (this.tabActive !== 2) {
        this.tabActive = 2;
        this.$nextTick(function () {
          _this5.restorePendingOutlineNode();
        });
        return;
      }
      var data = pendingNode.data || this.findPendingOutlineData(this.courseTree, pendingNode);
      if (!data) {
        return;
      }
      var node = pendingNode.node || this.$refs.courseTree && this.$refs.courseTree.getNode(data);
      if (!node) {
        return;
      }
      this.clearPendingOutlineNode();
      this.$nextTick(function () {
        _this5.handleNodeClick(data, node);
      });
    },
    changeTab: function changeTab(item, i) {
      this.tabActive = i;
      if (i == 1) {
        this.query.pageNum = 1;
        this.getCourseInfoNotice();
      }
    },
    //推荐课程列表
    getCourseList: function getCourseList() {
      var _this6 = this;
      (0, _recommendCourse.recommendList)({
        pageNum: 1,
        pageSize: 99999999999
      }).then(function (res) {
        _this6.courseList = res.rows;
      });
    },
    //获取课程详情
    getCourseDetail1: function () {
      var _getCourseDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, p, h, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _recommendCourse.reception)(this.$route.query.id);
            case 1:
              res = _context.sent;
              // console.log( '详情', res )
              this.courseDetail = res.data;
              p = parseInt(this.courseDetail.currentWeek / this.courseDetail.week * 100);
              h = (this.courseDetail.classHour / this.courseDetail.week).toFixed(2);
              this.$set(this.courseDetail, "progress", p);
              this.$set(this.courseDetail, "hourAweek", h);
              // console.log('this.courseDetail',this.courseDetail)
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.log("抛出错误：", _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCourseDetail1() {
        return _getCourseDetail.apply(this, arguments);
      }
      return getCourseDetail1;
    }(),
    getCourseInfoNotice: function getCourseInfoNotice() {
      var _this7 = this;
      (0, _recommendCourse.courseInfoNotice)(this.query).then(function (res) {
        _this7.noticeList = res.rows;
        _this7.noticeTotal = res.total;
      });
    },
    getCourseDesign: function getCourseDesign() {
      var _this8 = this;
      (0, _recommendCourse.courseDesign)({
        courseId: this.$route.query.courseId,
        courseInfoId: this.$route.query.id
      }).then(function (res) {
        // console.log(res)
        var arr = _this8.handleTree(res);
        _this8.courseTree = arr.map(function (i) {
          if (i.levelName != null) i.name = i.levelName + ' ' + i.name;
          if (i.children && i.children.length > 0) {
            i.children.map(function (u) {
              if (u.levelName != null) u.name = u.levelName + ' ' + u.name;
              if (u.children && u.children.length > 0) {
                u.children.map(function (y) {
                  if (y.levelName != null) y.name = y.levelName + ' ' + y.name;
                  if (y.children && y.children.length > 0) {
                    y.children.map(function (t) {
                      if (t.levelName != null) t.name = t.levelName + ' ' + t.name;
                    });
                  }
                });
              }
            });
          }
          return i;
        });
        console.log("this.courseTree", _this8.courseTree);
        _this8.$nextTick(function () {
          _this8.restorePendingOutlineNode();
        });
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getCourseInfoNotice();
    },
    handleNodeClick: function handleNodeClick(data, node, e) {
      var _this9 = this;
      console.log('handleNodeClick', data);
      // 阻止事件冒泡，确保移动端点击生效
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      if (!this.isLoggedIn) {
        this.savePendingOutlineNode(data);
        this.openLogin();
        return;
      }
      // 如果点击的是文件夹节点，需要切换展开状态
      if (!data.fileType || !['img', 'video', 'doc'].includes(data.fileType)) {
        // 没有 fileType 或不是可预览类型，切换展开/收起
        this.$nextTick(function () {
          if (_this9.$refs.courseTree && node) {
            // 关闭组件默认的行点击展开后，由当前节点统一控制展开状态。
            if (node.expanded) {
              node.collapse();
            } else {
              node.expand();
            }
          }
        });
        return;
      }
      // fileUrl 是一个 JSON 字符串，需要解析
      var fileData = data;
      if (data.fileUrl) {
        try {
          var urlData = JSON.parse(data.fileUrl);
          fileData = _objectSpread(_objectSpread({}, data), urlData);
        } catch (e) {
          console.log('fileUrl 解析失败，使用原始数据');
        }
      }
      this.currentFileData = fileData;
      this.fileStr = JSON.stringify(fileData);
      this.filePreviewVisible = true;
    },
    // 节点展开/收起事件
    handleNodeExpand: function handleNodeExpand(data, node, expanded) {
      if (!this.isLoggedIn) {
        if (expanded && node && node.collapse) {
          node.collapse();
        }
        this.savePendingOutlineNode(data);
        this.openLogin();
        return;
      }
      console.log('handleNodeExpand', data, expanded);
    },
    // 下载文件
    downloadFile: function downloadFile() {
      if (this.currentFileData && this.currentFileData.ossOriUrl) {
        var url = this.currentFileData.ossOriUrl;
        var fileName = this.currentFileData.fileName || '下载文件';
        // 创建临时下载链接
        var link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$message.warning('文件地址不存在');
      }
    },
    // 绑定移动端触摸事件
    bindMobileTouchEvents: function bindMobileTouchEvents() {
      var _this0 = this;
      this._treeTouchHandler = function (e) {
        var el = e.target.closest('.el-tree-node__content');
        if (el && _this0.$refs.courseTree) {
          // 找到对应的节点数据
          var tree = _this0.$refs.courseTree;
          var nodeMap = tree.store.nodesMap;

          // 遍历找到匹配的节点
          for (var key in nodeMap) {
            var node = nodeMap[key];
            if (node && node.elm === el.parentElement) {
              // 触发节点点击事件
              _this0.handleNodeClick(node.data, node, e);
              break;
            }
          }
        }
      };

      // 使用 passive 模式以提高滚动性能
      document.addEventListener('touchend', this._treeTouchHandler, {
        passive: true
      });
    },
    /**
     * 构造树型结构数据
     * @param {*} data 数据源
     * @param {*} id id字段 默认 'id'
     * @param {*} parentId 父节点字段 默认 'parentId'
     * @param {*} children 孩子节点字段 默认 'children'
     */
    handleTree: function handleTree(data, id, parentId, children) {
      var config = {
        id: id || "id",
        parentId: parentId || "parentId",
        childrenList: children || "children"
      };
      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];
      var _iterator2 = _createForOfIteratorHelper(data),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var d = _step2.value;
          var _parentId = d[config.parentId];
          if (childrenListMap[_parentId] == null) {
            childrenListMap[_parentId] = [];
          }
          nodeIds[d[config.id]] = d;
          childrenListMap[_parentId].push(d);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(data),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _d = _step3.value;
          var _parentId2 = _d[config.parentId];
          if (nodeIds[_parentId2] == null) {
            tree.push(_d);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      for (var _i = 0, _tree = tree; _i < _tree.length; _i++) {
        var t = _tree[_i];
        adaptToChildrenList(t);
      }
      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          var _iterator4 = _createForOfIteratorHelper(o[config.childrenList]),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var c = _step4.value;
              adaptToChildrenList(c);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
      return tree;
    }
  },
  created: function created() {
    this.getCourseDetail1();
    this.getCourseDesign();
    this.getSpeed();
  },
  mounted: function mounted() {
    var _this1 = this;
    // 为移动端添加触摸事件支持
    this.$nextTick(function () {
      _this1.bindMobileTouchEvents();
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 移除事件监听
    if (this._treeTouchHandler) {
      document.removeEventListener('touchend', this._treeTouchHandler);
    }
  }
};